import toast from "react-hot-toast";

let lastBidErrorToastId = null;

/**
 * Toast error untuk halaman lelang.
 * Toast sebelumnya ditutup lalu dibuat toast baru (id baru), supaya penolakan
 * berikutnya dengan pesan yang sama tetap terlihat sebagai notifikasi baru —
 * bukan sekadar memperbarui toast lama yang masih tampil.
 * @param {string} message - Pesan error
 */
export const showBidErrorToast = (message) => {
  if (lastBidErrorToastId) {
    toast.dismiss(lastBidErrorToastId);
  }
  lastBidErrorToastId = toast.error(message, { duration: 3000 });
  return lastBidErrorToastId;
};
